import { Link } from 'react-router-dom';
import { SERVICES } from '../../data/services';
import { assetUrl } from '../../lib/assetUrl';
import CheckIcon from '../icons/CheckIcon';
import './ServicesPreview.css';

export default function ServicesPreview() {
  return (
    <section className="section section--tinted services-preview" aria-labelledby="services-preview-title">
      <div className="container services-preview__inner">
        <div className="services-preview__media">
          <div className="media-frame services-preview__frame">
            <img src={assetUrl('images/services/main.png')} alt="" width="1080" height="1080" loading="lazy" />
          </div>
        </div>

        <div className="services-preview__content">
          <p className="eyebrow">What we offer</p>
          <h2 id="services-preview-title">Our Services</h2>
          <p className="lead">
            As an all encompassing animal care center, we provide a huge range of additional
            services alongside top of the line treatment. From surgeries to online consults and
            pet relocation, we&apos;ve got all your animal needs taken care of.
          </p>
          <ul className="services-preview__list" aria-label="Services">
            {SERVICES.map((service) => (
              <li key={service.id}>
                <CheckIcon />
                <span>{service.title}</span>
              </li>
            ))}
          </ul>
          <Link className="btn btn--primary" to="/Service">
            Explore Services
          </Link>
        </div>
      </div>
    </section>
  );
}
